import script from "./inventoryBrands.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryBrands.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryBrands.vue?vue&type=style&index=0&id=14e22004&lang=scss"

const __exports__ = script;

export default __exports__